"use strict";
// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// source: feature/feature-unauthenticated-service.proto
//
// GitHub:
// https://github.com/search?q=repo%3Agetstep%2Fserver+path%3Aproto%2Ffeature%2Ffeature-unauthenticated-service.proto&type=code
Object.defineProperty(exports, "__esModule", { value: true });
exports.FeatureUnauthenticatedServiceClient = exports.GetUnauthenticatedFeaturesResponse = exports.GetUnauthenticatedFeaturesRequest = void 0;
/* eslint-disable */
const rpc_1 = require("@getstep/proto-lib/rpc");
const feature_1 = require("./feature");
const protobufPackage = 'com.step.feature.proto';
function createBaseGetUnauthenticatedFeaturesRequest() {
    return { clientId: '' };
}
exports.GetUnauthenticatedFeaturesRequest = {
    fromJSON(object) {
        const message = {
            clientId: isSet(object.clientId) ? globalThis.String(object.clientId) : '',
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.clientId !== '') {
            obj.clientId = message.clientId;
        }
        return obj;
    },
    create(base) {
        return exports.GetUnauthenticatedFeaturesRequest.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUnauthenticatedFeaturesRequest();
        message.clientId = object.clientId ?? '';
        return message;
    },
};
function createBaseGetUnauthenticatedFeaturesResponse() {
    return { features: [], disabledFeatures: [] };
}
exports.GetUnauthenticatedFeaturesResponse = {
    fromJSON(object) {
        const message = {
            features: globalThis.Array.isArray(object?.features)
                ? object.features.map((e) => feature_1.FeatureAssignment.fromJSON(e))
                : [],
            disabledFeatures: globalThis.Array.isArray(object?.disabledFeatures)
                ? object.disabledFeatures.map((e) => (0, feature_1.featureFromJSON)(e))
                : [],
        };
        return message;
    },
    toJSON(message) {
        const obj = {};
        if (message.features?.length) {
            obj.features = message.features.map((e) => feature_1.FeatureAssignment.toJSON(e));
        }
        if (message.disabledFeatures?.length) {
            obj.disabledFeatures = message.disabledFeatures.map((e) => (0, feature_1.featureToJSON)(e));
        }
        return obj;
    },
    create(base) {
        return exports.GetUnauthenticatedFeaturesResponse.fromPartial(base ?? {});
    },
    fromPartial(object) {
        const message = createBaseGetUnauthenticatedFeaturesResponse();
        message.features = object.features?.map((e) => feature_1.FeatureAssignment.fromPartial(e)) || [];
        message.disabledFeatures = object.disabledFeatures?.map((e) => e) || [];
        return message;
    },
};
/**
 * Feature Flags API.
 *
 * Used by the client to lookup what features to enable.
 */
class FeatureUnauthenticatedServiceClient {
    rpc;
    name = 'com.step.feature.proto.FeatureUnauthenticatedService';
    type = rpc_1.ServiceType.UNAUTHENTICATED;
    path = '/feature';
    methods = [{
            name: 'GetUnauthenticatedFeatures',
            requestType: exports.GetUnauthenticatedFeaturesRequest,
            responseType: exports.GetUnauthenticatedFeaturesResponse,
            authenticationOptions: undefined,
            adminTokenType: undefined,
        }];
    constructor(rpc) {
        this.rpc = rpc;
    }
    /**
     * Get the features enabled for the user.
     */
    getUnauthenticatedFeatures(request, options = {}) {
        return this.rpc.call({
            path: this.path,
            service: this,
            method: this.methods[0],
            data: request,
            headers: {},
            context: {},
        }, options);
    }
}
exports.FeatureUnauthenticatedServiceClient = FeatureUnauthenticatedServiceClient;
function isSet(value) {
    return value !== null && value !== undefined;
}
//# sourceMappingURL=feature-unauthenticated-service.js.map